export default __webpack_public_path__ + "static/media/atlantaFalcons@2x.1d58a76e.jpg";